








































































import { isObject } from "@szgc/plt-core-v2";
import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";

import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "InputWidget",
  components: { MagicValidator }
})
export default class InputWidget extends EventWidgetComponent implements App.PuttedWidgetComponent {
  setValue(value: string) {
    this.value = value;
    this.operateHandler();
  }

  valueChange(value: string) {
    this.handleEvent(value);
    this.operateHandler();
  }

  mounted() {
    if (this.status === "mine") {
      this.value =
        this.widget.ext === null
          ? isObject(this.defaultValue)
            ? this.defaultValue.value
            : this.defaultValue
          : this.widget.value;
      this.$nextTick(() => {
        this.handleEvent(this.value);
        this.operateHandler();
      });
    }
  }
}
